/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Localcms_Resources_Frequently_Asked_QuestionsInputs */

const en_localcms_resources_frequently_asked_questions = /** @type {(inputs: Localcms_Resources_Frequently_Asked_QuestionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frequently asked questions`)
};

/**
* | output |
* | --- |
* | "Frequently asked questions" |
*
* @param {Localcms_Resources_Frequently_Asked_QuestionsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const localcms_resources_frequently_asked_questions = /** @type {((inputs?: Localcms_Resources_Frequently_Asked_QuestionsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Localcms_Resources_Frequently_Asked_QuestionsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_localcms_resources_frequently_asked_questions(inputs)
});